import { SortOrder } from '../grid';

import { AllowedActions } from './model/allowed-actions.model';
import { ByMeGridOptions } from './model/by-me-grid-options.model';
import { ColumnId } from './model/column-id.model';
import { ForMeGridOptions } from './model/for-me-grid-options.model';
import { ForMyTeamGridOptions } from './model/for-my-team-grid-options.model';
import { GridDays } from './model/grid-days.model';
import { GridType } from './model/grid-type.model';
import { TeamAlt } from './model/team-alt.model';

export interface LandingState {
    pending: {
        reload?: boolean;
    };

    allowedActions?: AllowedActions;

    gridOrder?: GridType[];

    forMe?: ForMeGridOptions;

    byMe?: ByMeGridOptions;

    forMyTeam?: ForMyTeamGridOptions;
}

export const defaultState = (): LandingState => ({
    pending: {},
    gridOrder: [GridType.FOR_ME, GridType.BY_ME, GridType.FOR_MY_TEAM],
    forMe: {
        type: GridType.FOR_ME,
        days: GridDays._30,
        sortOptions: {
            columnId: ColumnId.EVENT_DATE,
            order: SortOrder.DESC,
        },
    },
    byMe: {
        type: GridType.BY_ME,
        days: GridDays._30,
        sortOptions: {
            columnId: ColumnId.EVENT_DATE,
            order: SortOrder.DESC,
        },
    },
    forMyTeam: {
        type: GridType.FOR_MY_TEAM,
        teamAlt: TeamAlt.TEAM,
        days: GridDays._30,
        sortOptions: {
            columnId: ColumnId.EVENT_DATE,
            order: SortOrder.DESC,
        },
    },
});
